import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

export const GrossSalesProdChart = ({ startPeriod, endPeriod, ctrtDsaSd }) => {
  const rsrc = useRsrc();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    setLoading(true);
    setData(null); // reset so old chart doesn't flash while loading
    const reqParam = { startPeriod, endPeriod, ctrtDsaSd };
    rsrc.data('sc', 'GROSS_SALES_PROD_DATA_PLUGIN', reqParam)
      .then((resp) => { setData(resp); })
      .finally(() => { setLoading(false); });
  }, [startPeriod, endPeriod, rsrc]); // include rsrc to satisfy hooks rule

  if (loading) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <CircularProgress />
        <Typography mt={2}>Loading...</Typography>
      </Box>
    );
  }

  if (!data) return null;

  const products = Object.keys(data);
  if (!products.length) return null;

  const periods = Object.keys(data[products[0]] || {}).sort((a, b) => a.localeCompare(b));
  const series = products.map((prod) => ({
    label: prod,
    values: periods.map((p) => Number(data[prod]?.[p] ?? 0)),
    type: 'line',
  }));

  const chartData = {
    categories: periods,
    series: series,
  }

  return (
    <CartesianChart
      yLabel={'Sales Amount'}
      legend = {'top'}
      data = {chartData}
    />
  );
}
